var exports = {
  "e": "styledLogos__bMlQzr",
  "d": "styledTestimonial__l_H1sk",
};

module.exports = exports;
